import React from 'react';
import AuthWrapper from '../components/auth/AuthWrapper';

const AuthPage = () => {
  return <AuthWrapper />;
};

export default AuthPage;
